'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useAtomValue, useSetAtom } from 'jotai';
import { listingMapHighlightAtom } from '@/features/listing/atoms/listing-map-highlight-atom';
import ListingCardViewGrid from '@/features/listing/components/listing-card/listing-card-view-grid/listing-card-view-grid';
import ListingCardViewList from '@/features/listing/components/listing-card/listing-card-view-list/listing-card-view-list';
import { LISTING_VIEW_VARIANTS } from '@/features/listing/constants/listing-constants';
import { type ListingCardView, type ListingType, ListingTypeId } from '@/features/listing/types/listing-types';
import { loggedUserAtom } from '@/features/user/atoms/logged-user-atom';
import styles from './listing-card.module.scss';
import { type ListingCardBaseProps } from './listing-card-types';
interface ListingCardProps extends ListingCardBaseProps {
  hideBorder?: boolean;
  listingViewVariant?: ListingCardView;
}
export default function ListingCard(props) {
  const $ = _c(46);
  const {
    hideBorder: t0,
    isHighPriority: t1,
    isListingLinkDisabled: t2,
    link: t3,
    listing,
    listingViewVariant: t4,
    messageSrc,
    showBookmarkButton: t5,
    showCheckStatus: t6,
    showDescription: t7,
    showEditButton: t8,
    showListingUser: t9,
    showMessageButton: t10,
    showMissingData: t11,
    showMoveInDate: t12,
    showVerifications: t13
  } = props;
  const hideBorder = t0 === undefined ? false : t0;
  const isHighPriority = t1 === undefined ? false : t1;
  const isListingLinkDisabled = t2 === undefined ? false : t2;
  const link = t3 === undefined ? null : t3;
  const listingViewVariant = t4 === undefined ? LISTING_VIEW_VARIANTS.grid : t4;
  const showBookmarkButton = t5 === undefined ? true : t5;
  const showCheckStatus = t6 === undefined ? false : t6;
  const showDescription = t7 === undefined ? true : t7;
  const showEditButton = t8 === undefined ? false : t8;
  const showListingUser = t9 === undefined ? true : t9;
  const showMessageButton = t10 === undefined ? true : t10;
  const showMissingData = t11 === undefined ? false : t11;
  const showMoveInDate = t12 === undefined ? true : t12;
  const showVerifications = t13 === undefined ? true : t13;
  const setListingMapHighlight = useSetAtom(listingMapHighlightAtom);
  const loggedUser = useAtomValue(loggedUserAtom);
  const listingType = ListingTypeId[listing.listingTypeId] as ListingType;
  const isListingPerson = listingType === "needapartment" || listingType === "needroom";
  const isListingOfLoggedUser = loggedUser?.id === listing?.user.id;
  let t14;
  if ($[0] !== listing.geoLocation || $[1] !== listing.id || $[2] !== setListingMapHighlight) {
    t14 = () => {
      setListingMapHighlight({
        coordinates: listing.geoLocation,
        id: listing.id
      });
    };
    $[0] = listing.geoLocation;
    $[1] = listing.id;
    $[2] = setListingMapHighlight;
    $[3] = t14;
  } else {
    t14 = $[3];
  }
  const handleSetListingMapHighlight = t14;
  let t15;
  if ($[4] !== setListingMapHighlight) {
    t15 = () => {
      setListingMapHighlight(null);
    };
    $[4] = setListingMapHighlight;
    $[5] = t15;
  } else {
    t15 = $[5];
  }
  const handleRemoveListingMapHighlight = t15;
  const t16 = hideBorder && styles.listingCard__withoutBorder;
  let t17;
  if ($[6] !== t16) {
    t17 = cx(styles.listingCard, t16);
    $[6] = t16;
    $[7] = t17;
  } else {
    t17 = $[7];
  }
  let t18;
  if ($[8] !== isHighPriority || $[9] !== isListingLinkDisabled || $[10] !== isListingOfLoggedUser || $[11] !== isListingPerson || $[12] !== link || $[13] !== listing || $[14] !== listingViewVariant || $[15] !== messageSrc || $[16] !== showCheckStatus || $[17] !== showDescription || $[18] !== showEditButton || $[19] !== showListingUser || $[20] !== showMessageButton || $[21] !== showMissingData || $[22] !== showMoveInDate || $[23] !== showVerifications) {
    t18 = listingViewVariant === LISTING_VIEW_VARIANTS.grid && <ListingCardViewGrid showDescription={showDescription} listing={listing} showListingUser={showListingUser} showMessageButton={!isListingOfLoggedUser && showMessageButton} showMoveInDate={showMoveInDate} showVerifications={showVerifications} link={link} isListingPerson={isListingPerson} showMissingData={showMissingData} showCheckStatus={showCheckStatus} isListingLinkDisabled={isListingLinkDisabled} showEditButton={showEditButton} messageSrc={messageSrc} isHighPriority={isHighPriority} />;
    $[8] = isHighPriority;
    $[9] = isListingLinkDisabled;
    $[10] = isListingOfLoggedUser;
    $[11] = isListingPerson;
    $[12] = link;
    $[13] = listing;
    $[14] = listingViewVariant;
    $[15] = messageSrc;
    $[16] = showCheckStatus;
    $[17] = showDescription;
    $[18] = showEditButton;
    $[19] = showListingUser;
    $[20] = showMessageButton;
    $[21] = showMissingData;
    $[22] = showMoveInDate;
    $[23] = showVerifications;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== isHighPriority || $[26] !== isListingLinkDisabled || $[27] !== isListingPerson || $[28] !== link || $[29] !== listing || $[30] !== listingViewVariant || $[31] !== showBookmarkButton || $[32] !== showCheckStatus || $[33] !== showDescription || $[34] !== showListingUser || $[35] !== showMessageButton || $[36] !== showMissingData || $[37] !== showMoveInDate || $[38] !== showVerifications) {
    t19 = listingViewVariant === LISTING_VIEW_VARIANTS.list && <ListingCardViewList showDescription={showDescription} listing={listing} showListingUser={showListingUser} showMessageButton={showMessageButton} showMoveInDate={showMoveInDate} showVerifications={showVerifications} link={link} isListingPerson={isListingPerson} showMissingData={showMissingData} showCheckStatus={showCheckStatus} showBookmarkButton={showBookmarkButton} isListingLinkDisabled={isListingLinkDisabled} isHighPriority={isHighPriority} />;
    $[25] = isHighPriority;
    $[26] = isListingLinkDisabled;
    $[27] = isListingPerson;
    $[28] = link;
    $[29] = listing;
    $[30] = listingViewVariant;
    $[31] = showBookmarkButton;
    $[32] = showCheckStatus;
    $[33] = showDescription;
    $[34] = showListingUser;
    $[35] = showMessageButton;
    $[36] = showMissingData;
    $[37] = showMoveInDate;
    $[38] = showVerifications;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== handleRemoveListingMapHighlight || $[41] !== handleSetListingMapHighlight || $[42] !== t17 || $[43] !== t18 || $[44] !== t19) {
    t20 = <div className={t17} onMouseEnter={handleSetListingMapHighlight} onMouseLeave={handleRemoveListingMapHighlight}>{t18}{t19}</div>;
    $[40] = handleRemoveListingMapHighlight;
    $[41] = handleSetListingMapHighlight;
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
}